export function Impressum() {
  return (
    <div className="portfolio impressum-layout">
      <div className="noise-overlay" aria-hidden="true" />

      <nav className="nav nav--scrolled">
        <a href="/" className="nav-logo">NK</a>
      </nav>

      <section className="impressum-section">
        <div className="container">
          <header className="section-header">
            <span className="section-num">§</span>
            <h1 className="section-title">Impressum</h1>
          </header>

          <div className="impressum-body">
            <h2 className="impressum-heading">Angaben gemäß § 5 TMG</h2>
            <p>
              Nicolai Kobras<br />
              Am Wasen 4<br />
              63776 Mömbris
            </p>

            <h2 className="impressum-heading">Kontakt</h2>
            <p>
              E-Mail:{" "}
              <a href="mailto:mail@nicolaikobras.de" className="impressum-link">
                mail@nicolaikobras.de
              </a>
            </p>

            <h2 className="impressum-heading">Haftung für Inhalte</h2>
            <p>
              Als Diensteanbieter bin ich gemäß § 7 Abs. 1 TMG für eigene Inhalte
              auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach
              §§ 8 bis 10 TMG bin ich als Diensteanbieter jedoch nicht verpflichtet,
              übermittelte oder gespeicherte fremde Informationen zu überwachen oder
              nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit
              hinweisen.
            </p>

            <h2 className="impressum-heading">Haftung für Links</h2>
            <p>
              Mein Angebot enthält Links zu externen Websites Dritter, auf deren
              Inhalte ich keinen Einfluss habe. Deshalb kann ich für diese fremden
              Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten
              Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten
              verantwortlich.
            </p>

            <h2 className="impressum-heading">Urheberrecht</h2>
            <p>
              Die durch den Seitenbetreiber erstellten Inhalte und Werke auf diesen
              Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
              Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
              Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des
              jeweiligen Autors bzw. Erstellers.
            </p>
          </div>
        </div>
      </section>

      <footer className="site-footer">
        <span>© 2026 Nicolai Kobras</span>
        <a href="/#impressum" className="footer-link">Impressum</a>
      </footer>
    </div>
  );
}

export default Impressum;
